import { FetchProps, fetchData } from 'queries/fetchData'

export const fetchAudioData =
    (rootPath: string) =>
    async ({
        env,
        accessToken,
        location,
        dynamicSubPath,
        current_date,
        filters,
        method = 'GET',
        trackEvent,
        prepend_footer_to_rows = false,
    }: FetchProps<null>): Promise<string> => {
        return fetchData<string>(
            rootPath,
            true,
        )({
            env,
            accessToken,
            location,
            dynamicSubPath,
            current_date,
            filters,
            method,
            trackEvent,
            prepend_footer_to_rows,
        })
    }
